const REQUIRED_LINK_DEVICE_TYPES = new Set([
  JSON.stringify({ model: 'DT000002', subType: '' }),
  JSON.stringify({ model: 'DT000002', subType: 'DS200003' }),
  JSON.stringify({ model: 'DT000006', subType: '' }),
  JSON.stringify({ model: 'DT000006', subType: 'DS200004' }),
]);

export function isRequiredLinkDevice(deviceType?: string | null): boolean {
  if (!deviceType) {
    return false;
  }

  return REQUIRED_LINK_DEVICE_TYPES.has(deviceType);
}
